import { render, staticRenderFns } from "./ScreenInventario.vue?vue&type=template&id=f68f1d94"
import script from "./ScreenInventario.vue?vue&type=script&lang=js"
export * from "./ScreenInventario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports